import {store} from "@/scripts/globals";

export default {
    data: function () {
        return {
            store,
        }
    },
    computed: {
        isSubscribed() {
            return this.activePriceIds.length > 0;
        },
        activePriceIds() {
            const subs = this.subscriptions;
            let priceIds = [];
            if (!subs.length) {
                return priceIds;
            }
            subs.forEach((sub) => {
                priceIds.push(sub.extPriceId);
            });
            return priceIds;
        },
        subscriptions() {
            return this.store.myUser?.subscriptions ?? [];
        },
    }
}